export default ({
  apiUrl,
  get,
}) => {

  const isWhitelisted = (address) => {
    return get({
      url: apiUrl,
      endPoint: '/v1/iswhitelisted',
      contentType: 'application/json',
      data: {
        address,
      },
    });
  }

  const getRefId = (refAddress) => {
    return get({
      url: apiUrl,
      endPoint: '/v1/ref',
      contentType: 'application/json',
      data: {
        refAddress,
      },
    });
  }

  const getRefAddress = (refId) => {
    return get({
      url: apiUrl,
      endPoint: '/v1/ref',
      contentType: 'application/json',
      data: {
        refId,
      },
    });
  }

  return {
    isWhitelisted,
    getRefId,
    getRefAddress,
  };
}
